
oebbx-language-nav {
    display: flex;
    gap: 0;

    @media screen and (max-width: 1240px) {
        display: none;
    }

    &.language-nav-open,
    &:has(:hover) {
        .lang-nav {
            display: block;
        }

        .language-nav__wrapper {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
        }

        oebb-arrow-down-icon {
            transform: rotate(180deg) translateY(-3px);
        }
    }

    .language-nav__wrapper {
        position: relative;
        background: #E1E1E1;
        border-radius: 14px;
    }

    .language-nav__toggler {
        background: transparent;
        padding: 2px 5px 3px;
        display: flex;
        gap: 4px;
        border: none;

        color: #565151;
        display: flex;
        cursor: pointer;
        position: relative;
        z-index: 1;

    }

    .lang-nav {
        background: #E1E1E1;

        display: none;
        width: 100%;
        position: absolute;
        top: 1rem;
        right: 0;
        padding-block: 1rem .5rem;


        border-bottom-left-radius: 14px;
        border-bottom-right-radius: 14px;

        &[class$="-nav"] > li {
            display: block;
            width: 100%;

            > a {
                display: block;
                margin: 0;
            }
        }

    }

    .langauge-nav__active-lang {
        font-size: 14px;
        text-transform: uppercase;
        color: #565151;
        pointer-events: none;
        padding-inline: 1.625rem .5rem;
        margin-left: -1.125rem;
        border: 1px solid #e1e1e1e1;
        border-radius: 14px;
        display: flex;
        align-items: center;
    }
}